import { render, staticRenderFns } from "./EditorialSets.vue?vue&type=template&id=e6e5df80&scoped=true&lang=pug&"
import script from "./EditorialSets.vue?vue&type=script&lang=js&"
export * from "./EditorialSets.vue?vue&type=script&lang=js&"
import style0 from "./EditorialSets.vue?vue&type=style&index=0&id=e6e5df80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e5df80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6e5df80')) {
      api.createRecord('e6e5df80', component.options)
    } else {
      api.reload('e6e5df80', component.options)
    }
    module.hot.accept("./EditorialSets.vue?vue&type=template&id=e6e5df80&scoped=true&lang=pug&", function () {
      api.rerender('e6e5df80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/EditorialSets.vue"
export default component.exports